import React from "react";
import style from "./square.module.scss";
const SquareComtainer = (props) => {
  return (
    <div>
      <div
        style={{ zIndex: props.zIndex ? props.zIndex : 1000 }}
        className={`${style.popup_container}`}
      >
        <div>
          <div className={style.popup_header}>
            <div>{props.topComponent}</div>
          </div>

          <div className={style.popup_body}>
            <div>{props.childComponent}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SquareComtainer;
